interface Option {
  value: string;
  label: string;
}

interface Props {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  ariaLabel?: string;
}

const SegmentedControl: React.FC<Props> = ({
  options,
  value,
  onChange,
  ariaLabel,
}) => {
  return (
    <div className="segmentedControl" role="tablist" aria-label={ariaLabel}>
      {options.map((o) => {
        const isActive = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`segmentedControl__option${
              isActive ? " segmentedControl__option--active" : ""
            }`}
            onClick={() => {
              if (!isActive) onChange(o.value);
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
